import { API_PATHS } from '../constants/paths';
import type { UserApi } from '../types/api';
import type { HttpClient } from '../types/httpClient';
import { send } from '../utils/send';

/** The signed-in user's profile; the transport sends the token. */
export function createUserApi(http: HttpClient): UserApi {
    return {
        getProfile: () => send(http, 'resource', API_PATHS.USER_PROFILE),

        updateProfile: (body) => send(http, 'resource', API_PATHS.USER_PROFILE_UPDATE, { method: 'POST', body }),
    };
}
